// Month
export const SELECT_MONTH = 'SELECT_MONTH';
export const SELECT_NEXT_MONTH = 'SELECT_NEXT_MONTH';
export const SELECT_PREVIOUS_MONTH = 'SELECT_PREVIOUS_MONTH';

// Infobox
export const DISPLAY_INFOBOX = 'DISPLAY_INFOBOX';
export const HIDE_INFOBOX = 'HIDE_INFOBOX';

// Selection
export const ADD_AREA_TO_SELECTION = 'ADD_AREA_TO_SELECTION';
export const REMOVE_AREA_FROM_SELECTION = 'REMOVE_AREA_FROM_SELECTION';
export const REMOVE_ALL_AREAS_FROM_SELECTION = 'REMOVE_ALL_AREAS_FROM_SELECTION';
export const SHOW_SELECTION = 'SHOW_SELECTION';
export const HIDE_SELECTION = 'HIDE_SELECTION';
export const HIDE_PROMO = 'HIDE_PROMO';

// Selection Options
export const UPDATE_OPTION = 'UPDATE_OPTION';

// User Location
export const REQUEST_USER_LOCATION = 'REQUEST_USER_LOCATION';
export const RECEIVE_USER_LOCATION = 'RECEIVE_USER_LOCATION';
export const SET_DEFAULT_CITY = 'SET_DEFAULT_CITY';
export const SET_DEFAULT_CURRENCY = 'SET_DEFAULT_CURRENCY';
export const CUSTOMIZE_LOCATION = 'CUSTOMIZE_LOCATION';
export const CUSTOMIZE_CURRENCY = 'CUSTOMIZE_CURRENCY';

// Prices
export const REQUEST_PRICES = 'REQUEST_PRICES';
export const RECEIVE_PRICES = 'RECEIVE_PRICES';

// Autoplay
export const AUTOPLAY_STOP = 'AUTOPLAY_STOP';



/** WEBPACK FOOTER **
 ** ./src/constants/actionTypes.js
 **/